<app-ti-admin-menu></app-ti-admin-menu>
<main class="scrollbar-gray">
  <router-outlet></router-outlet>
</main>
<p-toast [class]="'inline'"></p-toast>
